// src/components/AuthGuard.js
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from './AuthContext';

const AuthGuard = ({ children }) => {
  const { authState } = useContext(AuthContext);
  const location = useLocation();
  if (!authState.isAuthenticated) {
    console.log(authState.isAuthenticated);
    // Redirect them to the /login page if not logged in
    return <Navigate to="/login" state={{ from: location }} replace />;
  }else{
    console.log(authState.isAuthenticated);
  }

  return children;
};

export default AuthGuard;
